module.exports = __webpack_public_path__ + "static/55import-5ca100a46a484a00c5ca32742d6a2f67.png";